<template>
    <main>
        <div class="row mt-2">
            <div class="list-group mb-3 col-lg-4 col-md-12 col-sm-12" v-for="(item) in $v.eventos_violencia.$each.$iter" :key="item.id">
                <div class="list-group-item">
                    <div class="d-flex align-items-center justify-content-between">
                        <buttonsCheck 
                            :antecedente="item.$model" 
                            :label="item.$model.descripcion" 
                            :type="item.$model.tipo_campo.codigo"
                            :validator="item"
                            v-model="item.$model.evento_sexual.valor">
                        </buttonsCheck>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import buttonsCheck from '../baseButtonsCkeck/indexButtonsNoOptions';
import eventoViolenciaSexualService from '../../../../services/eventoViolenciaSexualService';
import eventoViolenciaSexualUsuarioService from '../../../../services/eventoViolenciaSexualUsuarioService';
import {required} from "vuelidate/lib/validators";
import { isEmpty } from 'lodash';
import Toast from '../../../../components/common/utilities/toast';
export default {
    props: ['embarazo_actual', 'usuario', 'idHistoria', 'finalizada', 'modo'],
    components: { buttonsCheck },
    data() {
        return {
            type: 'store',
            eventos_violencia: []
        }
    },
    validations(){
        return {
            eventos_violencia:{
                $each:{
                    evento_sexual:{
                        valor:{required}
                    },
                }
            }
        }
    },
    methods:{
        async save() {
            try {
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }

                let eventos_violencia_usuario = [];

                this.eventos_violencia.forEach((x) => {
                    if (x.evento_sexual.valor !== "") {
                        eventos_violencia_usuario.push({ ...x.evento_sexual });
                    }
                });

                this.LoaderSpinnerShow();
                await eventoViolenciaSexualUsuarioService.store({
                    eventos_violencia_usuario: eventos_violencia_usuario,
                });
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con éxito'
                });
            } catch (error) {
                this.LoaderSpinnerHide();
                console.log(error);
                Toast.fire({
                    icon: 'error',
                    title: 'Ha ocurrido un error al procesar la solicitud'
                });
            }
        },
    },
    async created() {
        const filter = {
            sexo: this.usuario.sexo,
            fecha_nacimiento: this.usuario.fecha_nacimiento,
            ...(!isEmpty(this.embarazo_actual) && this.embarazo_actual.activo === 'S' ? { gestante: 'S' } : {})
        };

        const response = await eventoViolenciaSexualService.index({
            params: filter
        });

       const eventos_violencia_usuario = await eventoViolenciaSexualUsuarioService.index(
            this.idHistoria
        ); 

        this.eventos_violencia = response.data.map((y) => {
            const indice = eventos_violencia_usuario.data.findIndex(
                (a) => a.id_evento_sexual === y.id
            );
            y.evento_sexual = {
                id: indice !== -1 ? eventos_violencia_usuario.data[indice].id : 0,
                id_usuario: this.usuario.id,
                id_evento_sexual: y.id,
                id_historia:this.idHistoria,
                valor: indice !== -1 ? eventos_violencia_usuario.data[indice].valor : "",
            };
            return y;
        }); 
    }

}
</script>